import { DataWithPagination, TBaseProject } from '@/core/types'
import { createCatalogEndpoint, createNestedCrudEndpoints } from '@/core/utils'
import { TCatalogs, TLot } from './types'

export type TProjects = DataWithPagination<TBaseProject>

export type TLots = DataWithPagination<TLot>

export const serviceConfig = {
  model: 'projects',
  version: 'v1',
  lots: {
    model: 'lots',
    version: 'v1',
  },
  lotStatus: {
    model: 'lots/status',
    version: 'v1',
  },
}

const { lots, lotStatus } = serviceConfig

const lotsService = createNestedCrudEndpoints<TLots, TLot>(
  serviceConfig.model,
  lots.model,
  lots.version,
)

const lotStatusService = createCatalogEndpoint<TCatalogs>(
  lotStatus.model,
  lots.version,
)

export { lotsService, lotStatusService }
